import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "393292656988";
const WHATSAPP_MESSAGE = encodeURIComponent("Ciao! Vorrei informazioni sui vostri servizi.");

const WhatsAppButton = () => {
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-btn fixed bottom-6 right-6 z-50 w-16 h-16 bg-[#25D366] hover:bg-[#128C7E] rounded-full flex items-center justify-center shadow-2xl animate-pulse-green transition-all"
      data-testid="whatsapp-button"
      aria-label="Contattaci su WhatsApp"
    >
      <MessageCircle className="w-8 h-8 text-white" fill="white" />
    </a>
  );
};

export default WhatsAppButton;
